import { usePostDesignsMutation } from '@/api/serverApi'
import { Button, PlusIcon } from '@cfs-fixings/shared'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import CreateProjectModal from '../modals/projects/CreateProjectModal'

type PropTypes = {
  children: React.ReactNode
}

const textSpec = {
  createProjectButtonLabel: 'New Project',
  createDesignButtonLabel: 'New Design File',
}

const CreateButtonHeader = ({ children }: PropTypes) => {
  const navigate = useNavigate()

  const [isCreatingDesign, setIsCreatingDesign] = useState(false)
  const [isCreateOpen, setIsCreateOpen] = useState(false)

  const [createDesign] = usePostDesignsMutation()

  const handleCreateDesign = () => {
    setIsCreatingDesign(true)
    createDesign({ body: {} })
      .unwrap()
      .then(result => {
        return navigate(`/designs/${result.data.id}`)
      })
      .catch(() => {
        setIsCreatingDesign(false)
      })
  }

  return (
    <>
      <div className="flex justify-between grow items-center">
        <div className="flex md:justify-between md:grow items-center flex-wrap gap-y-2 gap-x-1">

          {children}

          <div className="flex flex-row gap-2.5">
            <Button
              variant="secondary"
              onClick={() => setIsCreateOpen(true)}
            >
              <div className="flex items-center md:text-sm text-xs">
                <PlusIcon className="w-full max-w-[8px] aspect-square mr-[7px]" />
                <span>{textSpec.createProjectButtonLabel}</span>
              </div>
            </Button>

            <Button
              onClick={handleCreateDesign}
              isLoading={isCreatingDesign}
            >
              <div className="flex items-center md:text-sm text-xs">
                <PlusIcon className="w-full max-w-[8px] aspect-square mr-[7px]" />
                <span>{textSpec.createDesignButtonLabel}</span>
              </div>
            </Button>
          </div>
        </div>

        <div className="w-[1px] h-[30px] bg-gray-400 ml-[25px]" />
      </div>
      <CreateProjectModal
        isOpen={isCreateOpen}
        onClose={() => setIsCreateOpen(false)}
        onSuccess={(project) => navigate(`/projects/${project?.id}`)}
      />
    </>
  )
}

export default CreateButtonHeader
